
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-import-dialog',
  templateUrl: './import-dialog.component.html',
  styleUrls: ['./import-dialog.component.scss']
})
export class ImportDialogComponent {
     constructor(
       @Inject(MAT_DIALOG_DATA)
       public data: {
         isCreate: boolean;
         isCreateUpdate: boolean;
         isMessage: boolean;
         title: string;
         subTitle: string;
         response: string;
       },
       private dialog: MatDialog,
       private router: Router
     ) {}
     
     async ngOnInit(): Promise<void> {
     
     }

    
   
     closeDialog() {
       this.dialog.closeAll();
     }
}
